
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/c/black-friday-cyber-monday",
      function () {
        return require("private-next-pages/c/black-friday-cyber-monday.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/c/black-friday-cyber-monday"])
      });
    }
  